module.exports = "<div class=\"wrapper\">\n  <app-header (toggle)=\"toggleSidebar($event)\"></app-header>\n  <app-sidebar [ngClass]=\"{'sidebar-effect':!sideBarState}\" ></app-sidebar>\n  <div class=\"content-wrapper\"  [ngClass]=\"{'collapse-side':!sideBarState}\">\n      <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main